import { type FunctionComponent } from 'react';
import React, { Suspense, useEffect } from 'react';

import { ADMIN_LINK_PREFIX, useNavigateA } from './Admin/Utils/LinkPrefix';
import LoadingScreenOverlay from './components/LoadingScreenOverlay';
import { useCognitoSignedUserState } from './reducers/cognitoUserReducer';
import { tlbUserIsSignedIn, useAnyTlbUserState } from './reducers/tlbUserReducer';
import { FeatureFlagPanel } from './utils/featureFlags/FeatureFlagsPanel';
import ImpersonationBanner from './utils/Impersonation/ImpersonationBanner';

const TlbApp = React.lazy(async () => import('./App'));
const TechApp = React.lazy(async () => import('./Technicians/TechnicianApp'));
const OpsApp = React.lazy(async () => import('./Admin/Admin'));

type AppSelectorProps = {};

const AppSelector: FunctionComponent<AppSelectorProps> = () => {
    const user = useCognitoSignedUserState();
    const tlbUser = useAnyTlbUserState();
    const userGroups = user.groups;
    const navigateA = useNavigateA();

    const isInOps = globalThis.location.pathname.startsWith(ADMIN_LINK_PREFIX);
    const isPilot = userGroups.includes('usr');
    const isTech = userGroups.includes('tch');
    const isFlb = userGroups.includes('flb');

    useEffect(() => {
        if (!isInOps && !tlbUserIsSignedIn(tlbUser)) {
            navigateA('/');
        }
        if (isFlb && !globalThis.location.pathname.startsWith(`${ADMIN_LINK_PREFIX}/flightboard`)) {
            navigateA('/flightboard');
        }
        // TODO: fix this and solve correctly!
        // eslint-disable-next-line react-hooks/exhaustive-deps -- TODO
    }, [navigateA]);

    return (
        <Suspense fallback={<LoadingScreenOverlay />}>
            <FeatureFlagPanel />
            <ImpersonationBanner />
            {isFlb || isInOps ? <OpsApp /> : isTech && !isPilot ? <TechApp /> : <TlbApp />}
        </Suspense>
    );
};

export default AppSelector;
